import Skill from "../../components/Skill";
import DolapoText from "../../components/DolapoText";
import { TextAlign, TextStyle } from "../../props/enums";
import { SkillItems } from "../../props/interface";

function SkillsSection({ items }: SkillItems) {
  return (
    <section className="flex min-h-screen w-full flex-col justify-center bg-white/90 px-4 py-8 md:px-12 xl:px-20">
      <DolapoText
        fontWeight={TextStyle.BOLD}
        textalign={TextAlign.CENTER}
        size={28}
        color="#000000"
        hasMarginBottom={false}
        marginBottom={20}
        content="Skills"
        underline={true}
      />

      <div className="mt-10 flex flex-wrap justify-center gap-4">
        {items.map((item) => (
          <Skill key={item.title} title={item.title} skills={item.skills} />
        ))}
      </div>
    </section>
  );
}

export default SkillsSection;
